export default {
  pagePk: null,
  pageName: null,
  revisionPk: null,

  availablePageVersions: [],
  typeComponentCategories: [],
  componentsTree: [],

  showAdminToolbar: localStorage.getItem("showAdminToolbar") === "true",
  showGlsAdmin: localStorage.getItem("showGlsAdmin") === "true",

  editableMode: false,

  // un-use
  actualVersion: {},
  actualHistoryStep: "",
};
